import { Badge, Flex } from '@chakra-ui/react';
import { ICompanyGroups, ITools } from 'pages/UserManagement/types';
import { useTranslation } from 'helpers/languages/translations';

const AToolsListCell = ({ row: { values }, toolsList }: { row: { values: ICompanyGroups }; toolsList: ITools[] }) => {
    const list = values.tools.map((value) => toolsList.find((tool) => tool.id === Number(value)));
    const translate = useTranslation();

    const toolTranslate = (toolName: string) => {
        return translate(`cg.${toolName}`);
    };

    return (
        <Flex>
            {list
                .filter((tool) => tool && tool.name.length)
                .map((tool) => (
                    <Badge colorScheme="blue" marginRight={2}>
                        {tool && toolTranslate(tool.name)}
                    </Badge>
                ))}
        </Flex>
    );
};
export default AToolsListCell;
